// shared/pdf/documents/LedgerDocument.jsx
import React from 'react';
import { Document, Page, View, Text, StyleSheet } from '@react-pdf/renderer';
import { PDF_THEMES, DEFAULT_THEME } from '../themes';
import PdfHeader from '../components/PdfHeader';
import PdfFooter from '../components/PdfFooter';
import PdfFilterLine from '../components/PdfFilterLine';
import { PdfTableHead, PdfTableRow, PdfTableFoot } from '../components/PdfTable';
import { fmtINR, fmtDate } from '../pdfUtils';

const s = StyleSheet.create({
  page:     { fontFamily: 'NotoSans', paddingBottom: 60 },
  content:  { marginHorizontal: 40, marginTop: 12 },
  acctName: { fontSize: 11, fontWeight: 'bold', marginBottom: 2 },
  acctCode: { fontSize: 8, marginBottom: 10 },
});

const COLS = [
  { label: 'Date',        flex: 0.9 },
  { label: 'Voucher No',  flex: 1.1 },
  { label: 'Narration',   flex: 3 },
  { label: 'Dr (₹)',      flex: 1, align: 'right' },
  { label: 'Cr (₹)',      flex: 1, align: 'right' },
  { label: 'Balance (₹)', flex: 1.2, align: 'right' },
];

export default function LedgerDocument({ data, theme: themeKey, orientation, sections, filters }) {
  const t = PDF_THEMES[themeKey] || PDF_THEMES[DEFAULT_THEME];
  return (
    <Document>
      <Page size="A4" orientation={orientation || 'portrait'} style={[s.page, { backgroundColor: t.white }]}>
        {sections.header && <PdfHeader derasar={data.derasar} reportTitle="Account Ledger" theme={t} />}
        <View style={s.content}>
          {sections.filterLine && <PdfFilterLine filters={filters} theme={t} />}
          {data.account && (
            <>
              <Text style={[s.acctName, { color: t.body }]}>{data.account.name}</Text>
              {data.account.accountCode && (
                <Text style={[s.acctCode, { color: t.muted }]}>Code: {data.account.accountCode}</Text>
              )}
            </>
          )}
          <PdfTableHead cols={COLS} theme={t} />
          {(data.rows || []).map((row, i) => (
            <PdfTableRow key={i} cols={COLS} index={i} theme={t}
              values={[fmtDate(row.date), row.voucherNo || '—', row.narration || '—', row.debit ? fmtINR(row.debit) : '—', row.credit ? fmtINR(row.credit) : '—', fmtINR(row.balance)]}
            />
          ))}
          <PdfTableFoot cols={COLS} values={['', '', 'Closing Balance', '', '', fmtINR(data.closingBalance)]} theme={t} />
        </View>
        {sections.footer && <PdfFooter theme={t} />}
      </Page>
    </Document>
  );
}


